import React, { useState, useContext } from 'react'
import PartnerSelect from '../../partner/components/PartnerSelect'
import * as actions from '../../auth/store/actions'
import { AppContext } from '../../index'
import { useHistory } from 'react-router-dom'

import LanguagePicker from '../../language/components/LanguagePicker'
import { useTranslation } from 'react-i18next'
import languages, { getLanguageDefinition } from '../../language/services'

import './UserMenu.css'

type Props = {
  isOpen: boolean
}

export function UserMenu(props: Props) {
  const { isOpen } = props
  const { execute, state } = useContext(AppContext)
  const [partnerSelectOpen, setPartnerSelectOpen] = useState(false)
  const [langSelectOpen, setLangSelectOpen] = useState(false)
  const { partners } = state.auth
  const partnerId  = state.partner.currentPartner ? state.partner.currentPartner.id : undefined
  const history = useHistory()

  const { t, i18n } = useTranslation(['navigation', 'global'])

  const currentLanguage = getLanguageDefinition(i18n.language)

  function setLanguage(code: string) {
    i18n.changeLanguage(code)
    setLangSelectOpen(false)
  }

  async function logout() {
    await execute(actions.logout())
  }

  function navigate(url: string) {
    history.push(url)
  }

  return (
    <>
      {partnerSelectOpen && (
        <PartnerSelect
          partners={partners}
          onCancel={() => setPartnerSelectOpen(false)}
          navigate={navigate}
          partnerId={partnerId}
        />
      )}

      {langSelectOpen && (
        <LanguagePicker
          languageDefinitions={languages}
          onCancel={() => setLangSelectOpen(false)}
          defaultLanguageCode={i18n.language}
          onSelectLanguage={setLanguage}
        />
      )}

      {isOpen && (
        <div>
          <div id="user-menu">
            <div id="language" className="user-menu-item" onClick={() => setLangSelectOpen(true)}>
              <span className={'flag-icon flag-icon-' + currentLanguage.flag}></span>&nbsp;
              {t('switch_language')}
            </div>

            {partners.length > 1 && (
              <div id="partner" className="user-menu-item" onClick={() => setPartnerSelectOpen(true)}>
                <i className="fas fa-portrait icon"></i>&nbsp;
                {t('switch_partner')}
              </div>
            )}

            <div id="logout" className="user-menu-item" onClick={logout}>
              <i className="fas fa-sign-out-alt icon"></i>&nbsp;
              {t('logout')}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
